import { Component } from '@angular/core';

@Component({
  selector: 'app-fleet-management',
  imports: [],
  templateUrl: './fleet-management.component.html',
  styleUrl: './fleet-management.component.scss'
})
export class FleetManagementComponent {

}
